var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Dt=require("moment");module.exports=$CLJS.Dt;